export const graphqlBaseUrl = process.env.REACT_APP_BACKEND_URL;
export const paysackBaseUrl = "https://api-stage.paysack.com/demo";
export const SOLANA_CLUSTER = process.env.REACT_APP_SOLANA_CLUSTER;
export const SOL_LEDGER_ACCOUNT = "";
